import { Injectable } from "@angular/core";
import { HotToastService } from "@ngxpert/hot-toast";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  constructor(private snackbar: HotToastService) {}

  showSuccess(message: string) {
    this.snackbar.success(message);
  }

  showError(message: string) {
    this.snackbar.error(message);
  }

  showInfo(message: string) {
    this.snackbar.info(message);
  }

  showLoading(message: string) {
    this.snackbar.loading(message);
  }
}
